import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface AnalyticsConfig {
  yandex_metrika_id: string;
  vk_pixel_id: string;
  enable_tracking: boolean;
  custom_head_code: string;
}

export function TrackingScripts() {
  const [config, setConfig] = useState<AnalyticsConfig | null>(null);

  useEffect(() => {
    supabase
      .from("settings")
      .select("value")
      .eq("key", "analytics_config")
      .single()
      .then(({ data }) => {
        if (data?.value) setConfig(data.value as unknown as AnalyticsConfig);
      });
  }, []);

  useEffect(() => {
    if (!config?.enable_tracking) return;

    // Yandex.Metrika — load immediately to capture UTM params before user navigates away
    if (config.yandex_metrika_id) {
      const id = config.yandex_metrika_id;
      (window as any).__YM_ID__ = Number(id);

      (window as any).ym = (window as any).ym || function (...args: unknown[]) {
        ((window as any).ym.a = (window as any).ym.a || []).push(args);
      };
      (window as any).ym.l = Date.now();
      (window as any).ym(Number(id), "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
      });

      const script = document.createElement("script");
      script.src = "https://mc.yandex.ru/metrika/tag.js";
      script.async = true;
      document.head.appendChild(script);
    }

    // VK Pixel — can be deferred slightly
    const loadDeferred = () => {
      if (config.vk_pixel_id) {
        (window as any).__VK_PIXEL_ID__ = config.vk_pixel_id;
        (window as any)._tmr = (window as any)._tmr || [];
        (window as any)._tmr.push({
          id: config.vk_pixel_id,
          type: "pageView",
          start: Date.now(),
        });

        const script = document.createElement("script");
        script.src = "https://top-fwz1.mail.ru/js/code.js";
        script.async = true;
        document.head.appendChild(script);
      }

      // Custom head code
      if (config.custom_head_code) {
        const container = document.createElement("div");
        container.innerHTML = config.custom_head_code;
        Array.from(container.childNodes).forEach((node) => {
          if (node.nodeName === "SCRIPT") {
            const newScript = document.createElement("script");
            const oldScript = node as HTMLScriptElement;
            if (oldScript.src) {
              newScript.src = oldScript.src;
              newScript.async = true;
            } else {
              newScript.textContent = oldScript.textContent;
            }
            document.head.appendChild(newScript);
          } else {
            document.head.appendChild(node.cloneNode(true));
          }
        });
      }
    };

    // Defer non-critical scripts
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(loadDeferred);
    } else {
      setTimeout(loadDeferred, 1000);
    }
  }, [config]);

  return null;
}
